import { render, staticRenderFns } from "./data-management.vue?vue&type=template&id=1ef07ed7&"
import script from "./data-management.vue?vue&type=script&lang=js&"
export * from "./data-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "data-management.vue"
export default component.exports